<template>
  <div class="playerWrap">
    <div class="videoGesture" @click="$emit('videoClick')"></div>

    <video
      ref="player"
      id="player"
      class="video-js vjs-theme-city"
      :class="{
        isHide: !showHideFlag
      }"
      controls
      muted
      autoplay
      playsinline
      preload="auto"
      data-setup="{}"
    >
      <source
        ref="playerSource"
        :src="this.playMedia.src"
        :type="this.playMedia.type"
      />
    </video>

    <div class="controls" v-if="mode === 'vod'">
      <button class="btn_play" @click="play" v-if="!state"></button>
      <button class="btn_pause" @click="pause" v-if="state"></button>

      <div class="currentTime">{{ currentTime }}</div>

      <div class="track" ref="track">
        <button class="field" @click="track($event)">
          <span class="runningBar" :style="{ width: `${currentPercent}%` }">
            <button class="grab"></button>
          </span>
        </button>
      </div>

      <!-- <div class="qualityBox">
        <ul class="qualityList" :style="{height: qOpen ? `${(3 * 30)}px` : '0px'}">
          <li>
            <button @click="changeQuality(QUALITY['auto'].idx)" :class="{on: selected === QUALITY['auto'].idx}">Auto</button>
          </li>
          <li>
            <button @click="changeQuality(QUALITY['1080'].idx)" :class="{on: selected === QUALITY['1080'].idx}">1080P</button>
          </li>
          <li>
            <button @click="changeQuality(QUALITY['720'].idx)" :class="{on: selected === QUALITY['720'].idx}">720P</button>
          </li>
          <li>
            <button @click="changeQuality(QUALITY['360'].idx)" :class="{on: selected === QUALITY['360'].idx}">360P</button>
          </li>
        </ul>

        <button class="toggleQualityList" @click="qOpen = !qOpen">{{nowQuality}}</button>
      </div> -->

      <div class="duration">{{ duration }}</div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.min.css'
import videojs from 'video.js'
import '@videojs/http-streaming'
// import 'videojs-contrib-hls'
import 'videojs-contrib-quality-levels'

export default {
  name: 'VideoPlayer',
  props: [
    'playMedia',
    'poster',
    'showHideFlag',
    'options',
    'mode',
    'idx',
    'timeUpdateFlag',
    'autoplay'
  ],

  data() {
    return {
      player: null,
      state: false,
      duration: '00:00',
      currentTime: '00:00',
      currentPercent: 0,
      eventBinding: false,
      videoQuality: null,
      selectedIndex: 0,

      QUALITY: {
        auto: {
          idx: -1,
          value: 'Auto'
        },
        // '1080': {
        //   idx: 0,
        //   value: 1080
        // },
        720: {
          idx: 0,
          value: 720
        },
        360: {
          idx: 0,
          value: 360
        }
      },
      THUMB_QUALITY: 240,

      qualityList: [],
      qOpen: false,
      selected: -1,
      nowQuality: 'Auto',
      seekLiveEdge: null,
      updated: false,
      mouseStatus : false,
      point : 0
    }
  },

  async mounted() {
    if (!this.playMedia.src) return false

    const DEF_ERR = {
      0: () => {
        alert('에러가 발생했습니다.')
      },
      1: () => {
        alert('에러가 발생했습니다.')
      },
      2: () => {
        alert('통신장애가 발생했습니다.')
      },
      3: () => {
        alert('에러가 발생했습니다.')
      },
      4: () => {
        // alert('영상정보를 읽어 올 수 없습니다.')
      }
    }

    const closeFunc = () => {
      this.$emit('playerClose')
    }

    this.player = videojs(
      this.$refs.player,
      this.options,
      function onPlayerReady() {
        console.log('onPlayerReady', this.player)

        // this.play()

        this.player.on('error', () => {
          const err = this.player.error()
          console.log(err)
          let currentTime = this.currentTime

          if (err.code === 2 || err.code === 3) {
            this.error(null).pause().load().currentTime(currentTime).play()
          } else if (err.code === 4) {
            console.log(
              'code 4 error: retry - Change the video src to the original src!'
            )
            this.player.src({
              src: this.playMedia.src,
              type: this.playMedia.type
            })
          }

          // DEF_ERR[this.error().code]()

          // return closeFunc()
        })
      }.bind(this)
    )

    this.player.playsinline(true)

    // this.videoQuality = this.player.qualityLevels()

    // // 화질 지정이 있으면 화질변경

    // // 화질목록 생성
    // let idx = 0

    // this.videoQuality.on('addqualitylevel', (e) => {
    //   let flag = e.qualityLevel.id.includes('240')
    //   let vodQuality = e.qualityLevel.id.includes('720')

    //   if (this.options.quality === 'thumb') {
    //     if (flag) {
    //       e.qualityLevel.enabled = true
    //       this.changeQuality(idx)

    //     } else {
    //       e.qualityLevel.enabled = false
    //     }

    //   } else {
    //     if (vodQuality) {
    //       e.qualityLevel.enabled = true
    //     } else {
    //       e.qualityLevel.enabled = false
    //     }
    //   }

    //   // if (e.qualityLevel.id.includes('1080')) this.QUALITY['1080'].idx = idx
    //   if (e.qualityLevel.id.includes('720')) this.QUALITY['720'].idx = idx
    //   if (e.qualityLevel.id.includes('360')) this.QUALITY['360'].idx = idx

    //   idx++
    // })

    // this.videoQuality.on('change', () => {
    //   console.log('Quality Level changed!')
    //   console.log('New Level :', this.videoQuality[this.videoQuality.selectedIndex])

    //   if (this.idx) return false
    //   let str = this.player.vhs.playlists.media().attributes.NAME.split('-')
    //   let quality = str[str.length - 1].toUpperCase()
    //   this.nowQuality = quality
    // })

    // idx가 있으면 방송리스트임(메인)
    if (this.idx !== undefined) {
      this.$emit('player', { idx: this.idx, player: this.player })
    } else {
      this.$emit('player', this.player)
    }

    // 아래는 vod일때만 나타나는 영상 컨트롤 부분
    if (this.mode !== 'vod') return false

    // 아이폰 처리
    const UA = navigator.userAgent.toLowerCase()
    if (
      UA.indexOf('iphone') > -1 ||
      UA.indexOf('ipad') > -1 ||
      UA.indexOf('ipod') > -1 ||
      UA.indexOf('macintosh') > -1
    ) {
      this.player.load()
    }

    this.player.on('loadedmetadata', () => {
      if (!this.eventBinding) this.grabBinding('.grab')
      this.eventBinding = true

      if (this.autoplay) {
        this.player.play()
      }

      this.timeUpdate()
    })

    this.player.on('playing', () => {
      this.state = true

      this.$emit('playing', this.player)

      if (this.mode !== 'live') {
        return false
      }
      this.seekLiveEdge = setInterval(() => {
        this.player.liveTracker.seekToLiveEdge()
      }, 1000)
    })

    this.player.on('pause', () => {
      this.state = false

      if (this.seekLiveEdge) {
        clearInterval(this.seekLiveEdge)
        this.this.seekLiveEdge = null
      }
    })
  },

  methods: {
    changeQuality(index) {
      console.log(index)
      this.qOpen = false
      const ql = this.videoQuality.levels_

      // 화질 지정했을 때 (auto가 아니면)
      if (index !== -1) {
        ql[index].enabled = true
        ql.forEach((q, idx) => {
          if (index !== idx) q.enabled = false
        })
        this.videoQuality.selectedIndex_ = index
        this.videoQuality.trigger({ type: 'change', selectedIndex: index })
      }

      // auto 지정 했을 때
      else {
        ql.forEach((q) => (q.enabled = true))
        this.videoQuality.selectedIndex_ = -1
        this.videoQuality.trigger({ type: 'change', selectedIndex: -1 })
      }

      this.selected = index
    },

    timeUpdate() {
      if (!this.timeUpdateFlag) {
        return false
      }

      this.player.on('timeupdate', () => {
        if (this.updated) {
          return false
        }

        if (this.duration === '00:00') {
          const DURATION = this.player.duration()
          this.duration = this.formatSeconds(DURATION)
        }

        this.updated = true
        setTimeout(() => {
          this.updated = false
        }, 1000)

        let per = Number(
          ((this.player.currentTime() / this.player.duration()) * 100).toFixed(
            2
          )
        )

        this.currentTime = this.formatSeconds(this.player.currentTime())

        if (!isNaN(per)) this.currentPercent = per
      })
    },

    grabBinding(el) {
      const grab = document.querySelector(el)
      const app = document.getElementById('app')
      grab.addEventListener('touchmove', this.draging)
      grab.addEventListener('touchend', this.endDrag)
      this.$refs.track.addEventListener('mousedown', this.downPause)
      app.addEventListener('mousemove', this.draging)
      app.addEventListener('mouseleave', this.endDrag)
      app.addEventListener('mouseup', this.endDrag)
    },
    downPause() {
      this.mouseStatus = true
      if (!this.player.paused()) {
        this.player.pause() 
      } 
    },
    draging(e) {
      if(!this.mouseStatus) return false
      const left = this.$refs.track.offsetLeft
      const max = this.$refs.track.clientWidth
      if(e.changedTouches === undefined) {
        this.point = e.clientX - left
      } else {
          this.point = e.changedTouches[0].clientX - left
      }
      if (this.point < 0) this.point = 0
      if (this.point > max) this.point = max
      const percent = (this.point / max) * 100

      const currentTime = this.player.duration() * (this.point / max)
      this.currentTime = this.formatSeconds(currentTime)

      this.currentPercent = percent
    },

    endDrag(e) {
      if(!this.mouseStatus) return false
      // if (!this.player.paused()) return false
      const left = this.$refs.track.offsetLeft
      const max = this.$refs.track.clientWidth
      if(e.changedTouches === undefined) {
        this.point = e.clientX - left
      } else {
        this.point = e.changedTouches[0].clientX - left
      }
      if (this.point < 0) this.point = 0
      if (this.point > max) this.point = max
      const percent = (this.point / max) * 100
      const currentTime = this.player.duration() * (this.point / max)

      this.currentPercent = percent
      this.player.currentTime(currentTime)
      if (this.player.paused()) this.player.play()
      this.mouseStatus = false
    },

    play() {
      this.player.play()
    },

    pause() {
      this.player.pause()
    },

    track(e) {
      if (!e.target.classList.contains('field')) return false

      const left = e.target.offsetLeft
      const max = e.target.clientWidth
      const point = e.x - left
      const percent = (point / max) * 100
      const currentTime = this.player.duration() * (point / max)

      this.currentPercent = percent

      this.player.currentTime(currentTime)
    },

    formatSeconds(time) {
      let h = null
      if (parseInt(time / 3600) > 0) h = String(parseInt(time / 3600))
      let m = String(parseInt((time % 3600) / 60))
      let s = String(Math.round(time % 60))

      let duration = ''
      if (h) duration = h + ':'
      duration += m.length < 2 ? '0' + m : m
      duration += ':'
      duration += s.length < 2 ? '0' + s : s
      return duration
    }
  },

  watch: {
    playMedia: {
      deep: true,
      handler(nd, od) {
        if (nd.src !== od.src) {
          if (!this.player.paused) this.player.pause()
          this.duration = '00:00'
          this.currentTime = '00:00'
          this.currentPercent = 0

          this.player.src({ src: nd.src, type: nd.type })
          this.player.play()
          this.$emit('player', this.player)

          // this.player.updateSrc(nd.src)
        }
      }
    }
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style >
.playerWrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.playerWrap .videoGesture {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: calc(100% - 100px);
}

.playerWrap .video-js {
  width: 100%;
  height: auto;
}
.playerWrap video {
  width: 100%;
  object-fit: cover;
  object-position: 50% 25%;
}
.live .playerWrap .video-js {
  height: 100%;
}

/* UI CUSTOM */

.video-js:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  background: Rgba(0, 0, 0, 0.2);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
}
.video-js.vjs-paused:after {
  opacity: 1;
}

.video-js .vjs-tech {
  pointer-events: none;
}

/* pip button hidden */
.video-js .vjs-picture-in-picture-control {
  display: none;
}

/* big button (play) hidden */
.vjs-controls-disabled .vjs-big-play-button,
.vjs-error .vjs-big-play-button,
.vjs-has-started .vjs-big-play-button,
.vjs-using-native-controls .vjs-big-play-button {
  display: none;
}

.vjs-error .vjs-error-display .vjs-modal-dialog-content,
.vjs-error .vjs-error-display:before {
  display: none;
}

.vjs-paused .vjs-big-play-button {
  display: block;
}
.video-js.vjs-waiting .vjs-big-play-button {
  display: none;
}

.vjs-waiting .vjs-poster {
  display: inline-block;
}

.video-js .vjs-big-play-button {
  z-index: 8;
  top: 50%;
  left: 50%;
  width: 74px;
  height: 74px;
  border: none;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.video-js .vjs-big-play-button,
.video-js:hover .vjs-big-play-button {
  background: rgba(255, 255, 255, 0.3);
}

.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/ico/icon_play_wh_sm.png') calc(50% + 5px)
    50% / 66px no-repeat;
}

.video-js .vjs-fullscreen-control {
  display: none;
}
.video-js .vjs-volume-panel {
  display: none;
}

.video-js .vjs-control-bar {
  bottom: 10px;
  z-index: 5;
  background: transparent;
}
.video-js .isHide ~ .vjs-control-bar {
  display: none;
}
.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1;
}
.video-js .vjs-slider {
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}
.video-js .vjs-play-progress {
  border-radius: 2px 0 0 2px;
}

.video-js .vjs-control-bar {
  display: none;
}

.playerWrap .controls {
  display: flex;
  position: absolute;
  left: 0;
  bottom: 10px;
  z-index: 10;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  font-size: 0;
  flex-direction: row;
  box-sizing: border-box;
  transition: opacity 0.3s ease;
  opacity: 1;
}
.pipMod .playerWrap .controls {
  opacity: 0;
  pointer-events: none;
}

.playerWrap .controls .btn_play {
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_play_wh_sm.png') 50% 50% / 22px
    auto no-repeat;
  outline: none;
}
.playerWrap .controls .btn_pause {
  width: 30px;
  height: 30px;
  background: url('../../assets/img/ico/icon_fuzz_btn_wh@3x.png') 50% 50% / 22px
    auto no-repeat;
  outline: none;
}

.playerWrap .controls .track {
  flex-grow: 1;
  margin: 0 10px;
}

.playerWrap .controls .track .field {
  position: relative;
  width: 100%;
  height: 20px;
  margin-top: 5px;
  outline: none;
}
.playerWrap .controls .track .field:before {
  content: '';
  position: absolute;
  top: 9px;
  left: 0;
  z-index: 1;
  display: block;
  width: 100%;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
}

.playerWrap .controls .track .runningBar {
  position: relative;
  z-index: 3;
  display: block;
  width: 10%;
  height: 2px;
  background: #fff;
  pointer-events: none;
}
.playerWrap .controls .track .runningBar .grab {
  position: absolute;
  top: -14px;
  right: -15px;
  z-index: 4;
  display: block;
  width: 30px;
  height: 30px;
  pointer-events: visible;
  outline: none;
}
.playerWrap .controls .track .runningBar .grab:before {
  content: '';
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
}
.playerWrap .controls .currentTime {
  flex-basis: 30px;
  font-size: 12px;
  color: #fff;
  line-height: 30px;
}

.playerWrap .controls .duration {
  flex-basis: 30px;
  font-size: 12px;
  color: #fff;
  line-height: 30px;
}

.playerWrap .controls .qualityBox {
  position: relative;
  flex-basis: 52px;
  margin-right: 5px;
  font-size: 12px;
  color: #fff;
}
.playerWrap .controls .qualityBox .toggleQualityList {
  display: block;
  width: 100%;
  margin: 5px auto 0;
  padding: 2px 0;
  color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 0.6);
  font-size: 12px;
  outline: none;
}
.playerWrap .controls .qualityBox img {
  display: block;
  width: 100%;
}
.playerWrap .controls .qualityBox .qualityList {
  overflow: hidden;
  position: absolute;
  left: 0;
  bottom: 28px;
  z-index: 1006;
  width: 100%;
  height: 0;
  transition: height 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.6);
}
.playerWrap .controls .qualityBox .qualityList button {
  width: 100%;
  height: 22px;
  margin: 4px 0;
  padding: 0 4px;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
}
.playerWrap .controls .qualityBox .qualityList button.on {
  background: rgba(230, 22, 84, 0.6);
}

/* pip 모드 일떄 */
.pipMod .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar,
.pipMod .vjs-has-started .vjs-control-bar,
.pipMod .video-js .vjs-big-play-button {
  opacity: 0;
}
</style>